import { z } from "zod";

import { language } from "@rootreeweb/ns-helper";
import type { FormState } from "@rootreeweb/zod-to-elements";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";

import type { FormDefinition } from "../types.js";

import { consentTextEN, consentTime } from "./shared.js";

const contactEN: FormDefinition = {
	signature: "588527212df0ab24e3099eb80eaca287d7dd26d82436580e165dc93cb6e5ec6e",
	formID: "contact-form-en",
	schema: z.object({
		"First Name": z.string(),
		"Last Name": z.string(),
		Email: z.string().email(),
		"Reason for inquiry": z.union([
			z.literal("General"),
			z.literal("Sales"),
			z.literal("Accounts"),
			z.literal("Creative Services"),
			z.literal("Co-Packing"),
			z.literal("Pre-Press"),
			z.literal("Web"),
		]),
		Message: z.string().describe(createCustomSettings({ textArea: true })),
		Language: language,
		"Consent Text": consentTextEN,
		"Consent Time": consentTime,
	}),
	formOptions: {
		redirect: "https://rootree.ca/newsletter/thank-you/",
	},
	submissionOptions: {
		recipients: contactRecipients,
	},
};

/**
 * Get the recipients for the contact form.
 *
 * @param state The form state.
 * @returns The recipients.
 */
export function contactRecipients(state: FormState): string[] {
	const recipients = ["web@rootree.ca"];
	const reason = state["Reason for inquiry"] || state["Votre demande ?"];

	if (typeof reason !== "string") {
		return recipients;
	}
	const lookup = [
		{
			values: ["General", "Informations générales"],
			emails: ["info@rootree.ca"],
		},
		{
			values: ["Sales", "Ventes"],
			emails: ["sales@rootree.ca"],
		},
		{
			values: ["Accounts", "Comptes"],
			emails: ["accounting@rootree.ca"],
		},
		{
			values: ["Creative Services", "Services créatifs"],
			emails: ["design@rootree.ca"],
		},
		{
			values: ["Co-Packing", "Co-emballage"],
			emails: ["copacking@rootree.ca"],
		},
		{
			values: ["Pre-Press", "Création"],
			emails: ["prepress@rootree.ca"],
		},
	];

	const recipient = lookup.find((item) => item.values.includes(reason));
	if (recipient) {
		recipients.push(...recipient.emails);
	}

	return recipients;
}
export default contactEN;
